/*
 * Main JS
 * -------------------
 * This file contains global JS functionality.
 */
import '../base/global';
import '../modules/gwp-incart-hydrator';
import '../components/product-card-modal';
import '../modules/line-item-property-reorderer';
import { initCartVersionGuard } from '../components/cart-version-guard';

// Initialize gift wrap system
import '../gift-wrap/src/services/initializeGiftWrap';

// Block checkout while personalised lines added under an old cart version are in the cart (ALBAU-855).
initCartVersionGuard();

// Check if environment app ID is configured.
const environmentAppId = window.environmentAppId || window.settings?.environment_app_id;
if (!environmentAppId || environmentAppId.trim() === '') {
  console.error('❌ Environment App ID is missing or empty. Please configure settings.environment_app_id.');
}
